import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCyberSniper = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 64,
	height: 64,
	fill: "currentColor",
	viewBox: "0 0 64 64",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		fillRule: "evenodd",
		clipPath: "url(#a)",
		clipRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M32 15.62c-9.046 0-16.38 7.334-16.38 16.38 0 9.047 7.334 16.38 16.38 16.38S48.38 41.046 48.38 32 41.046 15.62 32 15.62M13.62 32c0-10.15 8.229-18.38 18.38-18.38S50.38 21.85 50.38 32c0 10.151-8.229 18.38-18.38 18.38S13.62 42.151 13.62 32" }),
			/* @__PURE__ */ _jsx("path", { d: "M32 5.33C17.27 5.33 5.33 17.27 5.33 32S17.27 58.67 32 58.67 58.67 46.73 58.67 32 46.73 5.33 32 5.33M3.33 32C3.33 16.166 16.166 3.33 32 3.33S60.67 16.166 60.67 32 47.834 60.67 32 60.67 3.33 47.834 3.33 32" }),
			/* @__PURE__ */ _jsx("path", { d: "M32 .61a1 1 0 0 1 1 1v60.78a1 1 0 1 1-2 0V1.61a1 1 0 0 1 1-1" }),
			/* @__PURE__ */ _jsx("path", { d: "M.61 32a1 1 0 0 1 1-1h60.78a1 1 0 1 1 0 2H1.61a1 1 0 0 1-1-1" })
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "a",
		children: /* @__PURE__ */ _jsx("path", { d: "M0 0h64v64H0z" })
	}) })]
});
export default SvgCyberSniper;
